import "../styles/PopUp.css"

const DiagConfirmation = (props) => {
    const { isOpen, onClose, type, action1, action2 } = props;

    if (!isOpen) return null;
    return (
        <div className={`overlay-layer ${isOpen ? "active" : ""}`} onClick={onClose}>
            <div className="modal-diag" onClick={(e) => e.stopPropagation()}>
                {type === "creating group" && (
                    <>
                        <span className="diag-message">Do you want to stop creating this team and discard it?</span>
                        <div className="buttons-container ed1">
                            <button className="cancel" onClick={onClose}>No, go back</button>
                            <button
                                className="trigger"
                                onClick={() => {
                                    action1();
                                    onClose();
                                }}>Yes, discard</button>
                        </div>
                    </>
                )}
                {type === "successfully created" && (
                    <>
                        <span className="diag-message">Creating team accepted! It will take a while for Microsoft to create a Team.</span>
                        <div className="buttons-container ed1">
                            <button
                                className="trigger"
                                onClick={() => {
                                    action1();
                                    onClose();
                                }}
                            >Got it</button>
                        </div>
                    </>
                )}
                {type === "successfully added" && (
                    <>
                        <span className="diag-message">Added members successfully!</span>
                        <div className="buttons-container ed1">
                            <button
                                className="cancel"
                                onClick={() => {
                                    action1();
                                    onClose();
                                }}
                            >Continue adding</button>
                            <button
                                className="trigger"
                                onClick={() => {
                                    action2();
                                    onClose();
                                }}
                            >Got it</button>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}

export default DiagConfirmation;